<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>PROCEDIMIENTOS CLINICOS</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{'tokenAtencion ' + tokenAtencion }}</span> -->

            <div 
              class="row d-flex align-items-center mt-1" 
              style="position: relative;"
            >
              <CommentEditor
                v-if="isAuditoria"
                field="procedimientos"
                :comentarios="comentarios"
              />
            </div>

            <ProcedimientosList
              onlyView
              v-if="procedimientos && procedimientos.length"
              v-model="procedimientos"
            />

            <EmptyResults
              v-if="!procedimientos || procedimientos.length === 0"
              :message="'No se encontraron procedimientos para mostrar.'"
            />
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { EmptyResults } from '@/shared/components';
import { procedimientosService } from '@/views/procesoclinico/services';
import { ProcedimientosList } from '@/views/procesoclinico/components';

import CommentEditor       from '../CommentEditor/CommentEditor.vue';

export default {
  name: "AtencionProcedimientos",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    isAuditoria: {
      type: Boolean,
      default: false
    },
  },

  components: {
    EmptyResults,
    CommentEditor,
    ProcedimientosList
  },

  data() {
    return {
      visibleBody: false,

      procedimientos:null,
      comentarios:{}
    };
  },

  created(){
    this.onGetData();
  },

  methods: {
    onVisibleBody() {
      this.visibleBody = !this.visibleBody
    },

    async onGetData(){
      const data = await procedimientosService.getByAtencion(this.tokenAtencion);
      console.log('los procedimientos', data);

      if (!data) return;
      this.procedimientos = data;
    }
  },

  watch: {

    comentarios:{
      deep: true,
      handler(newValue) {
        const comentario = newValue.procedimientos || null;
        this.$store.commit("setComentarios", { procedimientos: comentario });
      }
    }
  }
}
</script>
